/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Faq_Change_Voice_QuestionInputs */

const en_mobile_faq_change_voice_question = /** @type {(inputs: Mobile_Faq_Change_Voice_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Voice`)
};

const es_mobile_faq_change_voice_question = /** @type {(inputs: Mobile_Faq_Change_Voice_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar voz`)
};

/**
* | output |
* | --- |
* | "Change Voice" |
*
* @param {Mobile_Faq_Change_Voice_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_faq_change_voice_question = /** @type {((inputs?: Mobile_Faq_Change_Voice_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Faq_Change_Voice_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_faq_change_voice_question(inputs)
	return en_mobile_faq_change_voice_question(inputs)
});